<template>
  <b-card>
    <div slot="header">
      <b-button :to="{name: 'service-list', params: {save: true}}" size="sm" variant="link"><i class="fa fa-chevron-left" /></b-button>
      {{ caption }}
    </div>
    <b-form inline>
      <b-form-group label-for="productCode" label="产品：">
        <el-select class="mb-2" filterable id="productCode"
                   @change="changeProduct" v-model="productCode">
          <el-option v-for="product in products" :key="product.code" :label="product.name" :value="product.code" />
        </el-select>
      </b-form-group>
      <b-form-group label-for="tags" label="标签：">
        <el-select multiple filterable class="mb-2" id="tags" style="width:100%"
                   @change="changeTag" v-model="tags">
          <el-option v-for="tag in allTags" :key="tag.code" :label="tag.name" :value="tag.code" />
        </el-select>
      </b-form-group>
    </b-form>
    <b-table responsive="sm" :items="items" :fields="fields" :current-page="currentPage" >
      <template #cell(product_code)="row">
        {{ getProduct(row.item.product_code) }}
      </template>
      <template #cell(tags)="row">
        <b-badge v-for="tag in row.item.tags" variant="secondary" :key="tag">{{ tag }}</b-badge>
      </template>
      <template #cell(detail)="row">
        <b-link :to="{name: 'app-update', params: {serviceCode: serviceCode, appCode: row.item.code}, query: {productCode: row.item.product_code}}">
          <b-button size="sm" class="mr-2" variant="outline-warning">
            <span class="fa fa-edit"> 配置管理</span>
          </b-button>
        </b-link>
        <b-link :to="{name: 'app-data', params: {serviceCode: serviceCode, appCode: row.item.code}, query: {productCode: row.item.product_code}}">
          <b-button size="sm" class="mr-2" variant="outline-primary">
            <span class="fa fa-cloud-download"> 数据查询</span>
          </b-button>
        </b-link>
        <b-link :to="{name: 'app-stat', params: {serviceCode: serviceCode, appCode: row.item.code}, query: {productCode: row.item.product_code}}">
          <b-button size="sm" class="mr-2" variant="outline-primary">
            <span class="fa fa-bar-chart"> 数据统计</span>
          </b-button>
        </b-link>
      </template>
    </b-table>

    <nav>
      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="<<" next-text=">>" @change="changePage" hide-goto-end-buttons/>
    </nav>
  </b-card>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'
import utils from '@/utils/utils'

export default {
  name: 'app',
  mixins: [Error],
  data: () => {
    return {
      items: [],
      productCode: '',
      tags: [],
      products: [],
      allTags: [],
      fields: consts.APP_FIELDS,
      currentPage: 1,
      perPage: consts.DEFAULT_PER_PAGE,
      totalRows: 0
    }
  },
  computed: {
    serviceCode: function () {
      return this.$route.params.serviceCode
    },
    caption: function () {
      return this.$route.params.serviceCode + ' 实例列表'
    }
  },
  created () {
    this.$ajax.all([
      this.$ajax.get(api.getProductList()),
      this.$ajax.get(api.getAppTagList())
    ]).then(([productData, tagData]) => {
      this.products.push({
        code: '', name: '全部'
      })
      productData.products.forEach((product) => {
        this.products.push(product)
      })
      tagData.tags.forEach((tag) => {
        this.allTags.push({code: tag, name: tag})
      })
    })
    api.fetchListData(this, api.getAppList(this.serviceCode), 'apps')
  },
  methods: {
    changePage (page) {
      this.currentPage = page
      api.fetchListData(this, api.getAppList(this.serviceCode), 'apps', {
        'product_code': this.productCode, 'tags': this.tags
      })
    },
    changeProduct (value) {
      this.productCode = value
      api.fetchListData(this, api.getAppList(this.serviceCode), 'apps', {
        'product_code': value, 'tags': this.tags
      })
    },
    changeTag (value) {
      this.tags = value
      api.fetchListData(this, api.getAppList(this.serviceCode), 'apps', {
        'product_code': this.productCode, 'tags': value
      })
    },
    getType (type) {
      return utils.findInArray(consts.APP_STATUS, type, 'text')
    },
    getProduct (code) {
      return utils.findInArray(this.products, code, 'name', 'code')
    }
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?d0337fb0